import React from 'react';
import {Route, Routes} from 'react-router-dom';
import ContentStudioOnboardingGuard from '@/routes/content-studio/ContentStudioOnboardingGuard';
import ErrorToastRoute from '@/routes/content-studio/ErrorToastRoute';
import {ROUTES} from '@/config/routesConstants';
import ContentStudio from '@/views/content-studio';
import Assets from '@/views/content-studio/assets';
import DubbingPage from '@/views/content-studio/components/dubbing-page/DubbingPage';
import EmptyFeaturePage from '@/views/content-studio/components/empty-feature-page/EmptyFeaturePage';
import Home from '@/views/content-studio/components/home';
import ReformattingPage from '@/views/content-studio/components/reformatting-page';
import RephrasingPage from '@/views/content-studio/components/rephrasing-page';
import {FEATURE_ID} from '@/views/content-studio/constants';
import OnboardingWizard from '@/views/content-studio/onboarding/OnboardingWizard';
import ContentStudioPricingPage from '@/views/content-studio/pricing';

function ContentStudioRoutes() {
  return (
    <Routes>
      <Route element={<ContentStudio />}>
        <Route element={<ContentStudioOnboardingGuard />}>
          <Route element={<ErrorToastRoute />}>
            <Route path="/" element={<Home />} />
            <Route path="/onboarding" element={<OnboardingWizard />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/feature" element={<EmptyFeaturePage />} />
            <Route path="/feature/dub" element={<DubbingPage />} />
            <Route path="/feature/rephrase" element={<RephrasingPage />} />
            <Route path="/feature/reformat" element={<ReformattingPage />} />
            <Route
              path="/feature/assets"
              element={
                <Assets
                  featureDetails={{
                    name: 'Edit',
                    navString: ROUTES.CONTENT_LAB_FEATURE,
                    icon: '',
                    isMultipleSelect: true,
                  }}
                />
              }
            />
            <Route
              path="/feature/dub/assets"
              element={
                <Assets
                  featureDetails={{
                    id: FEATURE_ID.DUB,
                    name: 'Dub',
                    navString: ROUTES.CONTENT_LAB_TRANSLATE,
                    icon: 'Navigation-Messages',
                    isMultipleSelect: true,
                  }}
                />
              }
            />
            <Route
              path="/feature/rephrase/assets"
              element={
                <Assets
                  featureDetails={{
                    id: FEATURE_ID.REPHRASE,
                    name: 'Rephrase',
                    navString: ROUTES.CONTENT_LAB_REPHRASE,
                    icon: 'Features-Rename',
                    isMultipleSelect: false,
                  }}
                />
              }
            />
            <Route
              path="/feature/reformat/assets"
              element={
                <Assets
                  featureDetails={{
                    id: FEATURE_ID.RESIZE,
                    name: 'Resize',
                    navString: ROUTES.CONTENT_LAB_REFORMAT,
                    icon: 'Actions-Expand',
                    isMultipleSelect: true,
                  }}
                />
              }
            />
            <Route path="/pricing" element={<ContentStudioPricingPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default ContentStudioRoutes;
